import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Divider } from "@mui/material";
import { IConfirmDialog } from "src/types/molecules";
const ConfirmDialog = ({
  open,
  cancelLabel,
  confirmLabel,
  cancelAction,
  confirmAction,
  title,
  subtitle,
  message,
  autoClose = true,
  contentRender,
  disabled = false,
  withEnter = false,
  withEscape = false,
  hideConfirm = false
}: IConfirmDialog) => {
  return <Dialog open={open} onClose={autoClose ? cancelAction : () => null} fullWidth sx={{
    maxWidth: 450,
    margin: "0 auto"
  }} onKeyDown={e => e.key.toLowerCase() === "enter" && withEnter ? confirmAction() : e.key.toLowerCase() === "escape" && withEscape ? cancelAction() : null}>
      <DialogTitle fontWeight={600}>{title}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText fontWeight={700}>{subtitle}</DialogContentText>
        <DialogContentText>{message}</DialogContentText>
        {contentRender}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button color="secondary" onClick={cancelAction}>
          {cancelLabel}
        </Button>
        {!hideConfirm && <Button onClick={confirmAction} disabled={disabled}>
            {confirmLabel}
          </Button>}
      </DialogActions>
    </Dialog>;
};
export default ConfirmDialog;